module.exports = __webpack_public_path__ + "static/media/upArrow.5e8359a7.svg";